import React, { Component } from 'react';

import './input.css';

export default class Input extends Component {
  render() {
    const {
      labelName,
      placeHolder,
      validationMessages,
      type,
      value,
      name,
      rows,
      onChange,
      id
    } = this.props;

    const buildInput = type === 'textarea' ?
      <textarea
        className={validationMessages ? 'form-control error' : 'form-control'}
        placeholder={placeHolder}
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
        id={id}
      /> :
      <input
        className={validationMessages ? 'form-control error' : 'form-control'}
        name={name}
        placeholder={placeHolder}
        type={type}
        value={value}
        onChange={onChange}
        id={id}
      />

    return (
      <div className={validationMessages ? 'input-container form-group row has-error' : 'input-container form-group row'}>
        <label htmlFor="colFormLabel" className="col-12 col-md-3 col-form-label">{labelName}</label>
        <div className="col-12 col-md-9">
          {buildInput}
          {/* {buildValidationMessages} */}
        </div>
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/components/Input/Input.js